import services from '@/services/index'
export default ({ $axios }, inject) => {
  // 全局拦截器处理
  $axios.onRequest((config) => config)
  // 全局响应配置
  $axios.onResponse((response) => {
    return response && response.data
  })
  //  模块注入功能
  const apiConfig = {}
  for (const i in services) {
    apiConfig[i] = services[i]($axios)
  }

  // 文档: https://www.nuxtjs.cn/guide/plugins
  // inject:注入到服务端context, vue实例, vuex中
  inject('api', apiConfig)
}
